(() => {
  const label = document.querySelector('[data-go-discount-label]').dataset.goDiscountLabel;
  const refine = () => {
    document.querySelectorAll('form.klaviyo-form button.klaviyo-form-button').forEach(button => {
      if (button.textContent.includes('SEND MY DISCOUNT')) {
        button.textContent = label;
        button.setAttribute('aria-label', label);
      }
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refine(); });
  }).observe(document.body, { childList: true, subtree: true });
  refine();
})();
(() => {
  const drawer = document.getElementById('ao-navigation');
  const toggle = document.querySelector('.ao-menu-toggle');
  if (!drawer || !toggle) return;
  toggle.addEventListener('click', () => { drawer.showModal(); toggle.setAttribute('aria-expanded', 'true'); });
  drawer.querySelector('.ao-menu-close').addEventListener('click', () => drawer.close());
  drawer.addEventListener('close', () => { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); });
  drawer.addEventListener('click', event => {
    const box = drawer.getBoundingClientRect();
    if (event.clientX > box.right || event.clientX < box.left) drawer.close();
  });
  let startX = 0;
  let startY = 0;
  drawer.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; startY = event.changedTouches[0].clientY; }, { passive: true });
  drawer.addEventListener('touchend', event => {
    const dx = event.changedTouches[0].clientX - startX;
    const dy = event.changedTouches[0].clientY - startY;
    if (dx < -70 && Math.abs(dx) > Math.abs(dy) * 1.5) drawer.close();
  }, { passive: true });
})();
